import { BoundaryCreateWMSOptimizedStatus } from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.state';
import { type TranslationFnc } from '../../../utils/hooks';

export const getWMSOptimizedTerritoriesProgressForStatus = (status: BoundaryCreateWMSOptimizedStatus): number => {
  switch (status) {
    case BoundaryCreateWMSOptimizedStatus.ValidatingRequest:
      return 5;
    case BoundaryCreateWMSOptimizedStatus.ProcessingStarted:
      return 20;
    case BoundaryCreateWMSOptimizedStatus.InitializingTerritories:
      return 30;
    case BoundaryCreateWMSOptimizedStatus.BalancingTerritories:
      return 40;
    case BoundaryCreateWMSOptimizedStatus.RebalancingTerritories:
      return 50;
    case BoundaryCreateWMSOptimizedStatus.FinalizingTheBalancingOfTerritories:
      return 60;
    case BoundaryCreateWMSOptimizedStatus.ProcessingFinished:
      return 80;
    case BoundaryCreateWMSOptimizedStatus.CalculatingStatistics:
      return 90;
    case BoundaryCreateWMSOptimizedStatus.Finished:
      return 100;
    default:
      return 0;
  }
};

export const getWMSOptimizedTerritoryStatusTranslation = (status: BoundaryCreateWMSOptimizedStatus, t: TranslationFnc): string => {
  switch (status) {
    case BoundaryCreateWMSOptimizedStatus.ProcessingStarted:
      return t('Processing Started');
    case BoundaryCreateWMSOptimizedStatus.ValidatingRequest:
      return t('Validating Request');
    case BoundaryCreateWMSOptimizedStatus.InitializingTerritories:
      return t('Initializing Territories');
    case BoundaryCreateWMSOptimizedStatus.BalancingTerritories:
      return t('Balancing Territories');
    case BoundaryCreateWMSOptimizedStatus.RebalancingTerritories:
      return t('Rebalancing Territories');
    case BoundaryCreateWMSOptimizedStatus.FinalizingTheBalancingOfTerritories:
      return t('Finalizing the Balancing of Territories');
    case BoundaryCreateWMSOptimizedStatus.ProcessingFinished:
      return t('Receiving finalized Territories');
    case BoundaryCreateWMSOptimizedStatus.CalculatingStatistics:
      return t('Calculating Statistics');
    case BoundaryCreateWMSOptimizedStatus.Finished:
      return t('Processing Finished');
    default:
      return '';
  }
};
